import { Grid, TextField, InputAdornment, MenuItem, FormControlLabel, Checkbox, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { updateCustomerField } from "../../redux/modules/CustomerInformation/census";
import ClearIcon from "@material-ui/icons/Clear"; // Add this import at the top
import styles from "./CustomerInformation.module.css";
import { keyDownValidation } from "../../redux/modules/CustomerInformation/customerInfoSchema";

const CustomerInformation = () => {
    const dispatch = useDispatch();
    const { customerData, errors } = useSelector((state) => state.census);

    const SUFFIX = ["Jr", "Sr", "II", "III", "IV"];

    const handleChange = (field, value) => {
        dispatch(updateCustomerField({ field, value }));
    };

    return (
        <div id="customerInformationForm">
            <Grid container direction="row" spacing={2}>
                <Grid container item md={6} justify="flex-start" alignItems="center" className="paymentHeader">
                    <label className={styles.modePaymentHeader}>Privacy Information and Consent</label>
                </Grid>
                <Grid container item md={12}>
                     <Typography className={styles.formControlLabel}><b>By processing this transaction, I declare that:</b> <i>The customer answering the Bayad Form has filled it up completely, including the Transaction Details and the SIGNED Personal Information section. I have checked with the customer that they have provided true and correct information and that they allow Bayad to collect and process their Personal Data as defined in the Terms & Conditions and the Privacy Notice displayed at the branch.</i></Typography>
                </Grid>
                <Grid container item md={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={customerData.consent === "True" ? true : false}
                                size="small"
                                onChange={() => handleChange("consent", customerData.consent === "False" ? "True" : "False") }
                            />
                        }
                        label={<Typography className={styles.formControlLabel}><b>Consent.</b> The customer allows Bayad to use their Personal Data for rewards and promotions and regular updates.</Typography>}
                        labelPlacement="end"
                    />
                </Grid>
            </Grid>
			<br/>
            <Grid container direction="row" spacing={2}>
                {/* First Name */}
                <Grid item lg={3} md={4} sm={12}>
                    <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={customerData.firstName}
                        onChange={(e) => handleChange("firstName", e.target.value)}
                        label={<Typography className={styles.inputLabel}> First Name<span className={styles.requiredAsterisk}>*</span></Typography>}
                        InputProps={{ classes: { root: `${customerData.firstName ? styles.inputWithValue : ""}`, disabled: `${styles.inputDisabled}` } }}
                        onKeyDown={keyDownValidation.alphaNameSpecialCharSpace}
                        //onPaste={keyDownValidation.preventPaste}
                        onCopy={keyDownValidation.preventCopy}
                        error={!!errors.firstName}
                        helperText={errors.firstName}
                    />
                </Grid>

                {/* Middle Initial */}
                <Grid item lg={3} md={4} sm={12}>
                    <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={customerData.middleInitial}
                        onChange={(e) => handleChange("middleInitial", e.target.value)}
                        label={<Typography className={styles.inputLabel}> Middle Initial (Optional) </Typography>}
                        InputProps={{ classes: { root: `${customerData.middleInitial ? styles.inputWithValue : ""}`, disabled: `${styles.inputDisabled}` } }}
                        onKeyDown={keyDownValidation.alphabetOnly}
                        //onPaste={keyDownValidation.preventPaste}
                        onCopy={keyDownValidation.preventCopy}
                        error={!!errors.middleInitial}
                        helperText={errors.middleInitial}
                    />
                </Grid>

                {/* Last Name */}
                <Grid item lg={3} md={4} sm={12}>
                    <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={customerData.lastName}
                        onChange={(e) => handleChange("lastName", e.target.value)}
                        label={<Typography className={styles.inputLabel}> Last Name<span className={styles.requiredAsterisk}>*</span></Typography>}
						InputProps={{ classes: { root: `${customerData.lastName ? styles.inputWithValue : ""}`, disabled: `${styles.inputDisabled}` } }}
                        onKeyDown={keyDownValidation.alphaNameSpecialCharSpace}
                        //onPaste={keyDownValidation.preventPaste}
                        onCopy={keyDownValidation.preventCopy}
                        error={!!errors.lastName}
                        helperText={errors.lastName}
                    />
                </Grid>

                {/* Suffix */}
                <Grid item lg={3} md={4} sm={12}>
                    <TextField
                        fullWidth
                        size="small"
                        select
                        variant="outlined"
                        value={customerData.suffix}
                        onChange={(e) => handleChange("suffix", e.target.value)}
                        label={<Typography className={styles.inputLabel}> Suffix (Optional) </Typography>}
						InputProps={{ 
                            classes: { 
                                root: `${customerData.suffix ? styles.inputWithValue : ""}`, 
                                disabled: `${styles.inputDisabled}` 
                            },
                            endAdornment: customerData.suffix && (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <InputAdornment position="end" style={{ cursor: "pointer", marginRight: 10 }}>
                                        <ClearIcon 
                                            fontSize="small" 
                                            onClick={() => handleChange("suffix", "")} 
                                            titleAccess="Clear selection"
                                        />
                                    </InputAdornment>
                                </div>
                            )
                        }}
                        error={!!errors.suffix}
                        helperText={errors.suffix}
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {SUFFIX.map((option, i) => (
                            <MenuItem key={i} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                {/* Mobile Number */}
                <Grid item lg={3} md={4} sm={12}>
                    <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={customerData.mobileNumber}
                        onChange={(e) => handleChange("mobileNumber", e.target.value)}
                        onKeyDown={keyDownValidation.mobileNumber}
                        //onPaste={keyDownValidation.preventPaste}
                        onCopy={keyDownValidation.preventCopy}
                        error={!!errors.mobileNumber}
                        helperText={errors.mobileNumber}
                        label={<Typography className={styles.inputLabel}>Mobile Number<span className={styles.requiredAsterisk}>*</span></Typography>}
                        InputProps={{ 
							classes: { root: `${customerData.mobileNumber ? styles.inputWithValue : ""}`, disabled: `${styles.inputDisabled}` },
                            startAdornment: customerData.mobileNumber ? <span className={styles.mobileNoAdorment}>+63</span> : "" }}
                    />
                </Grid>

                {/* Email Address */}
                <Grid item lg={3} md={4} sm={12}>
                    <TextField
                        fullWidth
                        size="small" 	
                        variant="outlined"
                        value={customerData.emailAddress}
                        onChange={(e) => handleChange("emailAddress", e.target.value)}
                        label={<Typography className={styles.inputLabel}> Email Address (Optional) </Typography>}
						InputProps={{ classes: { root: `${customerData.emailAddress ? styles.inputWithValue : ""}`, disabled: `${styles.inputDisabled}` } }}
                        onKeyDown={keyDownValidation.validEmailAddress}
                        //onPaste={keyDownValidation.preventPaste}
                        onCopy={keyDownValidation.preventCopy}
                        error={!!errors.emailAddress}
                        helperText={errors.emailAddress}
                    />
                </Grid>

                {/* Address */}
                <Grid item lg={3} md={4} sm={12}>
                    <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={customerData.address}
                        onChange={(e) => handleChange("address", e.target.value)}
                        label={<Typography className={styles.inputLabel}> Address (Optional) </Typography>}
						InputProps={{ classes: { root: `${customerData.address ? styles.inputWithValue : ""}`, disabled: `${styles.inputDisabled}` } }}
                        onKeyDown={keyDownValidation.alphaNumSpecialCharSpace}
                        //onPaste={keyDownValidation.preventPaste}
                        onCopy={keyDownValidation.preventCopy}
                        error={!!errors.address}
                        helperText={errors.address}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default CustomerInformation;
